<script setup>
import { onLaunch, onShow, onHide } from '@dcloudio/uni-app'

onLaunch(() => {
	console.log('App Launch')
})

onShow(() => {
	console.log('App Show')
})

onHide(() => {
	console.log('App Hide')
})
</script>

<template>
  <view></view>
</template>

<style lang="scss">
/* #ifndef APP-PLUS-NVUE */
@import '@/common/uni.css';
@import '@/common/touch.scss';

page {
  background-color: #F5F5F5;
  height: 100%;
  font-size: 28rpx;
  /* 主题色变量 */
  --primary-color: #E93B3D;
  --primary-color-light: #ffeeee;
  --primary-color-dark: #d61f21;
  
  /* 文字颜色 */
  --text-main: #333;
  --text-regular: #666;
  --text-secondary: #999;
  
  /* 边框颜色 */
  --border-color: #eee;
  --border-color-light: #f5f5f5;
  
  /* 背景色 */
  --bg-color: #f5f5f5;
  --bg-white: #ffffff;
  
  /* 圆角 */
  --border-radius-sm: 4rpx;
  --border-radius-base: 8rpx;
  --border-radius-lg: 12rpx;
  --border-radius-circle: 50%;
  
  /* 间距 */
  --spacing-sm: 12rpx;
  --spacing-base: 16rpx;
  --spacing-lg: 24rpx;
  --spacing-xl: 32rpx;
  
  /* 字体大小 */
  --font-size-sm: 24rpx;
  --font-size-base: 28rpx;
  --font-size-lg: 32rpx;
  --font-size-xl: 36rpx;
}

/* 页面切换动画配置 */
.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter-active {
  transition-duration: 0.3s;
}

.fade-leave-active {
  transition-duration: 0.3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* 全局基础样式优化 */
page {
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica,
    Segoe UI, Arial, Roboto, 'PingFang SC', 'miui', 'Hiragino Sans GB', 'Microsoft Yahei',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  
  /* 滚动优化 */
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
}

/* 移除按钮默认边框 */
button::after {
  border: none;
}

/* 图片默认模式 */
image {
  will-change: transform;
}

/* 去除长按菜单 */
view, text, navigator, input, image {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

/* 统一input placeholder样式 */
input::placeholder {
  color: #999;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* 全局样式 */
.container {
  min-height: 100vh;
  background-color: var(--bg-color);
  padding-bottom: calc(100rpx + env(safe-area-inset-bottom));
}

/* 卡片基础样式 */
.card {
  background: var(--bg-white);
  border-radius: var(--border-radius-lg);
  margin: var(--spacing-lg);
  padding: var(--spacing-xl);
}

/* 按钮基础样式 */
button {
  font-size: var(--font-size-base);
  border-radius: var(--border-radius-circle);
  
  &[type="primary"] {
    background-color: var(--primary-color);
    
    &.button-hover {
      background-color: var(--primary-color-dark);
    }
  }
}

/* #endif */
</style>
